// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1514":"da11845c","2422":"fc0d280c","5196":"c6bbae06","6190":"c6bbae06","6815":"e7d46292"}[chunkId] + ".chunk.css";
};